const InvoiceExcelArticle9Notice = () => (
  <div
    className='alert alert-light-info border border-info border-dashed d-flex align-items-start gap-3 text-start py-4 mb-8'
    role='note'
  >
    <i className='las la-info-circle fs-2x text-info' aria-hidden='true'></i>
    <div>
      <div className='fw-bold text-gray-800 mb-1'>راهنمای ماده ۹ در فایل اکسل</div>
      <div className='text-gray-700 fs-7'>
        نسخه جدید فایل نمونه شامل ستون‌های «ماده ۹» و «تاریخ و زمان ثبت صورتحساب» است. فایل‌های اکسل
        قبلی همچنان بدون تغییر قابل بارگذاری هستند.
      </div>
      <div className='text-gray-700 fs-7 mt-1'>
        در ستون «ماده ۹» مقدار «بله» یا «خیر» را وارد کنید؛ با انتخاب «بله»، تکمیل تاریخ و زمان ثبت
        صورتحساب الزامی است.
      </div>
    </div>
  </div>
)

export {InvoiceExcelArticle9Notice}
